import type { FaireProductEntity } from "../../entity_types/product";

export const p_p2tym9jj3s: FaireProductEntity = {
  token: "p_p2tym9jj3s",
  type: "product",
  name: "NEW Doggies Pet Bowl",
  brandToken: "b_65zgi875pr",
  brandName: "Laurel Burch Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/f0e8375b007555cd9c4ff9587f0cc75b5fadbebd9a0276c73aa317115a82dfb0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/584399dfbdcffc40226625a0b3614f15d8f9480a1c604d6e95c3ae2649b5c4f4.png",
  ],
  priceDollars: 11.7,
  description:
    "Bow-wowza! We based this new design on an early painting of Laurel’s beloved doggies. Delight yourself and your furry companion with this cheerful, well-crafted bowl featuring a parade of whimsical pups dancing across a starry blue sky. With room for two cups of food or water, it’s both practical and paw-sitively fun. \n\n• Removable stainless steel bowl\n• Colorful melamine base, anti-slip rubber bottom\n• Half-moon notch in base makes it easy to pick up\n• Dishwasher safe, top rack; do not microwave\n\nItem Number: PB004\nCapacity: 2-cup capacity \nDimensions: 1.75” bowl depth, 5.5” diameter. Base is 2.5”H with 7” diameter \nMaterial: Melamine, rubber; stainless steel\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:29.565Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
